import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Container, Header, Image, Button, Icon } from 'semantic-ui-react'
import { DiscussionEmbed } from 'disqus-react'
const h3style = {
  opacity: 0.5,
  marginTop: 0,
}

const description =
  'Часто задоваемые вопросы про наши Фэйковые Авиабилеты. Как быстро мы их делаем. Какие риски. PNR. Что делать в аэропорту и т.д. Читай дальше …'

const FAQ = ({ data }) => (
  <Container text>
    <Helmet>
      <title>Часто Задаваемые Вопросы - Fake Flight Tickets</title>
      <meta
        name='twitter:title'
        content='Часто Задаваемые Вопросы - Fake Flight Tickets'
      />
      <meta name='description' content={description} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content='/opengraph-image.ru.jpg' />
      <meta property='og:image' content='/opengraph-image.ru.jpg' />
    </Helmet>
    <Header as='h1' textAlign='center'>
      Часто Задаваемые Вопросы
    </Header>
    <Header as='h3' textAlign='center' style={h3style}>
      (пока на английском, но мы скоро переведём)
    </Header>
    <hr />
    <h2>✈️ Что такое {data.site.siteMetadata.ru.title}?</h2>
    <p>
      {data.site.siteMetadata.ru.title} — это сервис, который помогает вам решить проблему
      представления "доказательства продолжения поездки". Многие авиакомпании и страны
      требуют доказательства того, что вы намерены покинуть страну, прежде чем вам
      разрешат сесть на самолет. Мы все любим гибкость и часто не знаем, куда мы хотим
      полететь. Тратить сотни долларов, месяцы до поездки, — это дорогое, стрессовое
      испытание, которое убивает вашу свободу.
      <br />
      Мы тоже не любим это, и создали этот генератор фейковых авиабилетов.
    </p>

    <h2>⚙️ How does {data.site.siteMetadata.ru.title} work?</h2>
    <p>
      Мы берем общедоступную информацию о реальных рейсах по всему миру, объединяем ее с
      вашими личными данными и генерируем документ, подтверждающий бронирование, который
      выглядит точно так же, как настоящий! Практически невозможно отличить реальное
      подтверждение полета от того, что мы генерируем. <i>Если только</i> вы не позвоните
      и не проверите действительность билета у них.
    </p>

    <h2>✅ Какая информация реальная, а какая нет?</h2>
    <p>
      Мы используем реальный шаблон подтверждения бронирования популярного сайта
      бронирования, реальную информацию о рейсе: цену, номер рейса, дату и время вылета,
      продолжительность, пересадки и т.д. Мы генерируем наш уникальный номер маршрута и он{' '}
      <b>не реален</b>.
      <br />
      Читайте больше о реальной и сгенерированной информации в{' '}
      <a href='/blog/what-is-real-and-what-is-not'> этом блоге</a>.
    </p>

    <h2>🛂 Как себя вести в аэропорту?</h2>
    <p>
      В зависимости от вашей цели и паспорта вам могут потребоваться доказательства
      продолжения поездки во время регистрации. (Например, вы летите в Индонезию).{' '}
      <b>Ваш опыт может отличаться</b>, но вот что обычно происходит со мной и что я
      делаю:
      <br />
      <br />
      <ul>
        <li>Когда вам потребуют, я показываю своё доказательство продолжения поездки</li>
        <li>
          Человек, отвечающий за регистрацию, смотрит только номер рейса, авиакомпанию и
          дату. Он указывает пальцем на маршрут и вводит его в систему.
        </li>
        <li>
          По моему опыту, они не интересуются <b>номером маршрута</b> и не интересуются
          вашим номером PNR.
        </li>
        <li>
          If you are asked for your PNR confirmation number, you can always say:{' '}
          <i>
            "Вы только что купили этот билет несколько дней назад, поэтому, возможно,
            агент ещё не выдал настоящий билет"
          </i>
        </li>
      </ul>
      <p>
        Опять же, это основано на моем личном опыте. Ваш опыт может отличаться. Если у вас
        есть дополнительные советы и рекомендации, пожалуйста, напишите ниже.
      </p>
    </p>

    <h2>🤑 Отлично! Беру! Сколько стоит?</h2>
    <p>
      Мы взимаем плату, как за чашку кофе ☕ $5
      <br />
      Быстро. Хорошо. <b>Дешево</b>!
    </p>
    <Image src='https://media.giphy.com/media/A7BrncpC2Z8Ws/giphy.gif' centered />

    <h2>🧐 Билеты реальные?</h2>
    <p>
      Нет. Подтверждение бронирования, которое вы получите, не является реальным. Но оно
      полностью неотличимо (визуально) от настоящего.
    </p>

    <h2>Могу ли я получить возврат?</h2>
    <p>
      Нет. Мы не возвращаем деньги. Наши услуги просты и прямолинейны. Что вы видите, то и
      получаете. Кроме того, ваше время намного дороже, чем тратить его на возврат $5.
    </p>

    <h2>Что делать, если меня отказывают в посадке?</h2>
    <p>
      Вероятно, это произошло по другой причине, кроме вашего доказательства продолжения
      поездки. В любом случае, мы не несем ответственность за это. Ниже я дам несколько
      советов, как минимизировать ваши риски во время поездки. 👇
    </p>

    {/* <h2>Кто-нибудь из ваших клиентов был отказан в посадке?</h2>
    <p>
      Никто не жаловался. Проверьте нашу 👍{' '}
      <a href='https://www.trustpilot.com/review/fakeflighttickets.com' target='_blank'>
        Trustpilot
      </a>{' '}
      reviews.
    </p> */}

    <h2>Более полезные советы:</h2>
    <ul>
      <li>
        <b>Оденьтесь прилично</b> для аэропорта! Почему? Когда вы выглядите
        презентабельно, демонстрируете свой статус одеждой, часами и т.д... Это может
        произвести положительное впечатление на персонал регистрации авиакомпании. И
        минимизирует сомнения в том, что у вас не хватит денег, чтобы покинуть страну.
      </li>
      <li>
        <b>Выберите авиакомпанию, отличную от той, которой вы сейчас летите</b>. Например:
        если вы летите из Куала-Лумпура на Бали с AirAsia по билету в одну сторону —
        попробуйте выбрать "обратный билет" другой авиакомпании, например JetStar, KLM или
        другой... Не выбирайте AirAsia. Это не позволит AirAsia проверить, действителен ли
        ваш обратный билет на самом деле.
      </li>
      <li>
        <b>Распечатайте</b> ваш обратный билет. И все остальные проездные документы тоже.
      </li>
    </ul>

    <h2>😌 Что вдохновило нас создать этот сайт?</h2>
    <p>
      Международные авиаперелеты могут быть очень напряженными, и{' '}
      {data.site.siteMetadata.ru.title} стремится помочь вам сохранять спокойствие, что бы
      ни случилось в пути. 🧘
    </p>
    <Image
      src='https://media1.tenor.com/images/a1ba22175263ea13d6da30a517d6d904/tenor.gif?itemid=5626530'
      centered
    />
    <hr />
    <p>Счастливого полета! 👋</p>
    <p>
      С уважением,
      <br />
      {data.site.siteMetadata.ru.title}
    </p>

    <Button style={{ marginBottom: '3em' }} as={Link} to='/' color='green'>
      Получить ваши обратные билеты <Icon name='arrow right' />
    </Button>

    {/* <DiscussionEmbed
      shortname="fake-flight-tickets"
      config={{
        url: `https://www.fakeflighttickets.com/faq`,
        identifier: 'faq',
        title: 'FAQ',
      }}
    /> */}
  </Container>
)

export default FAQ

export const query = graphql`
  query TitleQueryRu {
    site {
      siteMetadata {
        ru {
          title
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/faq.ru.js